import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text } from '@b_v/components';
import Image from 'next/image';

import styles from './LandingBenefitsHero.module.scss';

type LandingBenefitsHeroPropsT = {
  scrollable: () => void;
};

const LandingBenefitsHero: React.FC<LandingBenefitsHeroPropsT> = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.LandingBenefitsHero}>
      <Text tag="h1" className={styles.LandingBenefitsHero__title}>
        <Trans components={{ span: <span /> }}>BENEFITS_HERO_TITLE</Trans>
      </Text>
      <Text tag="h3" className={styles.LandingBenefitsHero__subtitle}>
        <Trans components={{ span: <span /> }}>BENEFITS_HERO_TITLE_DESCRIPTION</Trans>
      </Text>

      <div className={styles.LandingBenefitsHero__benefits}>
        {[0, 1, 2].map((benefit) => (
          <div key={benefit} className={styles.LandingBenefitsHero__card}>
            <div className={styles.LandingBenefitsHero__card__image}>
              <Image fill src={`/images/benefits/benefit_${benefit + 1}.webp`} alt="" />
              <div className={styles.LandingBenefitsHero__card__image__badge}>
                {t('BENEFITS_HERO_BENEFITS_BADGET')}
              </div>
            </div>
            <div className={styles.LandingBenefitsHero__card__body}>
              <Text tag="h5" className={styles.LandingBenefitsHero__card__title}>
                {t(`BENEFITS_HERO.${benefit}.BENEFIT_TITLE`)}
              </Text>

              <Text tag="p" className={styles.LandingBenefitsHero__card__subtitle}>
                <Trans components={{ span: <span /> }}>
                  {t(`BENEFITS_HERO.${benefit}.BENEFITS_DESCRIPTION`)}
                </Trans>
              </Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingBenefitsHero;
